import { PAGE_CONTEXT_PREFIX, type PageContext } from "./pageContext";

export type DocumentScope =
  | { kind: "uploaded"; documentId: string; name: string }
  | { kind: "signed"; signedDocumentId: string; name: string };

export const documentScopeOf = (document: { id: string; name: string }, signed: boolean): DocumentScope =>
  signed
    ? { kind: "signed", signedDocumentId: document.id, name: document.name }
    : { kind: "uploaded", documentId: document.id, name: document.name };

export const documentScopeContext = (scope: DocumentScope): PageContext => {
  const reference =
    scope.kind === "uploaded" ? `documentId ${scope.documentId}` : `signedDocumentId ${scope.signedDocumentId}`;
  return {
    description:
      `${PAGE_CONTEXT_PREFIX} dokumentet «${scope.name}» (${reference}). Når brukeren sier «dokumentet» eller ` +
      "«dette dokumentet», er det dette. Les teksten med readDocumentText og denne id-en før du svarer, og oppgi " +
      "dokumentets navn og sidetall som kilde.",
  };
};
